import { AppProviders } from './providers';
import { AppRoutes } from './routes';

/**
 * Main Application Component
 */
export function App() {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}
